import ProposalOrientation from '@/types/proposal-orientation';
import { PROPOSAL_ORIENTATION } from './constants';
import IncomeStreamScenario from '@/types/income-stream-scenario';

export const MAX_DISTRIBUTION_SCENARIOS_PORTRAIT = 2;
export const MAX_DISTRIBUTION_SCENARIOS_LANDSCAPE = 3;

/**
 * Returns an sliced array of distribution scenarios that can fit based on proposal orientation
 * Note: Max 2 for portrait and 3 for landscape
 *
 * @param {ProposalOrientation} orientation Orientation
 * @param {IncomeStreamScenario[]} incomeStreamDistribution distribution scenarios
 * @return {IncomeStreamScenario[]} sliced array of distribution scenarios.
 */
export const getProposalDistributionScenarios = (orientation: ProposalOrientation, incomeStreamDistribution?: IncomeStreamScenario[]) => {
  if (!incomeStreamDistribution) {
    return [];
  }

  if (orientation === PROPOSAL_ORIENTATION.LANDSCAPE) {
    return incomeStreamDistribution.slice(0, MAX_DISTRIBUTION_SCENARIOS_LANDSCAPE);
  }

  return incomeStreamDistribution.slice(0, MAX_DISTRIBUTION_SCENARIOS_PORTRAIT);
};
